import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

// Pulsante con doppia conferma: mostra un pop-up prima di eseguire l'azione (soldi/irreversibili).
export function ConfirmButton({
  onConfirm, title = "Confermi l'operazione?", description,
  confirmText = "Conferma", cancelText = "Annulla",
  disabled, children, confirmTestId = "confirm-ok", beforeOpen, ...btnProps
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="button" disabled={disabled} onClick={() => { if (!beforeOpen || beforeOpen() !== false) setOpen(true); }} {...btnProps} className={`btn-ok ${btnProps.className || ""}`}>{children}</Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="confirm-cancel">{cancelText}</AlertDialogCancel>
            <AlertDialogAction className="btn-ok" data-testid={confirmTestId} onClick={() => onConfirm && onConfirm()}>{confirmText}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
